import React from "react";
import { Code2, Github } from 'lucide-react';

export default function Navbar() {
  return (
    <nav className="border-b border-slate-800 bg-slate-950/80 backdrop-blur-sm sticky top-0 z-50">
      <div className="container mx-auto px-4 py-4 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="w-10 h-10 bg-gradient-to-br from-cyan-500 to-emerald-500 rounded-lg flex items-center justify-center">
            <Code2 className="w-6 h-6 text-white" />
          </div>
          <div>
            <h1 className="text-xl font-bold">DP Generator</h1>
            <p className="text-xs text-slate-400">Dynamic Programming Made Easy</p>
          </div>
        </div>

        <div className="flex items-center gap-6">
          <a href="#visualizer" className="text-slate-300 hover:text-white transition-colors">
            Visualizer
          </a>
          <a href="#code-generator" className="text-slate-300 hover:text-white transition-colors">
            Code Generator
          </a>
          <a href="#resources" className="text-slate-300 hover:text-white transition-colors">
            Resources
          </a>
          <a
            href="https://github.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-slate-300 hover:text-white transition-colors">

            <Github className="w-5 h-5" />
          </a>
        </div>
      </div>
    </nav>);

}